// Getters (GET*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const AUTHENTICATION_IS_LOGGED = 'AUTHENTICATION_IS_LOGGED';

// Mutations (SET*, ADD*, REMOVE*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const AUTHENTICATION_SET_USER = 'AUTHENTICATION_SET_USER';
export const AUTHENTICATION_GET_USER = 'AUTHENTICATION_GET_USER';

// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
// [CONTEXT]_[ACTION]_[PROPERTY]_[STATUS]
export const AUTHENTICATION_LOGIN = 'AUTHENTICATION_LOGIN';
export const AUTHENTICATION_LOGOUT = 'AUTHENTICATION_LOGOUT';

export const AUTHENTICATION_GET_TOKEN = 'AUTHENTICATION_GET_TOKEN';
